import { SET_LOGINED, SET_USERINFO, SET_CALLING_CODE,CAPTCHA_TYPE } from './../store/ActionTypes'
import { getStorage, setStorage } from "utils/localstorage"
import { Authorization, UserInfo, OK, AuthTimeout } from "utils/constant"
import store from "store"
import { createAction } from "store/ActionTypes"
import { post, get } from 'utils/request'
import { getCaptcha } from "utils/utils"

export function isLogined() {
  const Auth = getStorage(Authorization)
  const userInfo = getStorage(UserInfo)
  return !!Auth && userInfo?.transocks_id
}

export function clearLoginInfo() {
  localStorage.removeItem(Authorization)
  localStorage.removeItem(UserInfo)
  store.dispatch(createAction(SET_LOGINED, false))
  store.dispatch(createAction(SET_USERINFO, {}))
}

export function setLoginInfo(userInfo: any, token?: string) {
  store.dispatch(createAction(SET_USERINFO, userInfo))
  setStorage(UserInfo, userInfo)
  if (token) {
    setStorage(Authorization, token)
    setStorage(AuthTimeout, Date.now() + (1000 * 60 * 60 * 24))
    store.dispatch(createAction(SET_LOGINED, true))
  }
}

export async function aliyuncaptcha(body){
  const data = await post('/2/check_intelligent_captcha', { body})
  return data
}

export async function $login(body: Record<string, any> | string) {
  let options = {
    body: body
  }
  let url = '/user/signin'

  if (typeof body === 'string') {
    url = '/user/login-token'
    options = {
      body: {
        token: body
      }
    }
  }else{
    if (getCaptcha()) {
      options={
        body:{
          ...body,
          test:undefined,
          captcha: getCaptcha()
        }
      }
      const data= await post('/2/user/signin', options)
      if (data.status === OK) {
        setLoginInfo(data.data, data.data.token.access_token)
      }
      return data
    }
  }
  const data = await post(url, options)
  if (data.status === OK) {
    setLoginInfo(data.data, data.data.token.access_token)
  }
  return data
}

export async function $login2(body: Record<string, any>) {
  let options = {
    body
  }
  if (getCaptcha()) {
    options={
      body:{
        ...body,
        test:undefined,
        captcha: getCaptcha(),
      }
    }
    return post('/2/user/signin', options)
  }

  return post('/user/signin', options)
}

export async function $signupPhone(body: any) {
  const options = {
    body: body
  }
  // if (window['captcha_type'] === 'yunpian') {
  //   options={
  //     body:{
  //       ...body,
  //       test:undefined,
  //       captcha: window['yunpian'],
  //     }
  //   }
  //   const data=await post('/2/user/signup', options)
  //   if (data.status === OK) {
  //     setLoginInfo(data.data, data.data.token.access_token)
  //   }
  //   return data
  // }

  const data = await post('/user/signup', options)
  if (data.status === OK) {
    setLoginInfo(data.data, data.data.token.access_token)
  }
  return data
}

export async function $register(email: string, password: string) {
  const options = {
    body: {
      email,
      password
    }
  }
  
  const data = await post('/user/register', options)
  return data
}

export async function $forgetPasswd(body: any) {
  // let options
  //人机验证为yunpian
  // if (window['captcha_type'] === 'yunpian') {
  // options = {
  //   body :{
  //     ...body,
  //     // captcha: window['yunpian'],
  //   }
  // }

  // return await post('/2/user/forgot-password', options)
  // }
  const options = {
    body  
  }

  
  return await post('/user/forgot-password', options)
}

export async function $changePasswd(oldpassword, newpassword1, newpassword2) {
  const options = {
    body: {
      oldpassword,
      newpassword1,
      newpassword2
    }
  }
  return await post('/user/change-password', options)
}

export async function $userInfo() {
  const options = {}
  const data = await get(`/2/user/info?t=${Date.now()}`, options)
  if (data.status === OK) {
    setLoginInfo(data.data)
  }
  return data
}

// 判断登录超时
export function isAuthTimeout() {
  const timeout = getStorage(AuthTimeout)
  const token = getStorage(Authorization)
  if (token) {
    if (!timeout || +timeout < Date.now()) {
      clearLoginInfo()
    }
  }
}

export async function getCallingCode() {
  const callingCode = getStorage(SET_CALLING_CODE)

  if (callingCode) {
    store.dispatch({ type: SET_CALLING_CODE, value: callingCode })
  }

  const options = {}
  const data = await get('/app/callingcode', options)
  if (data.status === OK) {
    setStorage(SET_CALLING_CODE, data.data)
    store.dispatch({ type: SET_CALLING_CODE, value: data.data })
  }

  return data
}

export async function sendSms(body: any, token?: string) {
  const options = {
    body: body
  }

  if (token) {
    options['headers'] = {
      Authorization: `Bearer ${token}`
    }
  }

  const data = await post('/user/sms', options)

  return data
}

export async function resetPasswd(body: any) {
  let options = {
    body
  }
  if (getCaptcha()) {
    options = {
      body :{
        ...body,
        captcha: getCaptcha(),
      }
    }

    return await post('/2/user/reset-password', options)
  }




  const data = await post('/user/reset-password', options)

  return data
}

export async function userBind(body: any, token?: string) {
  const options = {
    body,
  }

  if (token) {
    options['headers'] = {
      Authorization: `Bearer ${token}`
    }
  }
  if (getCaptcha()) {
    options.body = {
      ...body,
      test:undefined,
      captcha:getCaptcha()
    }
    return  await post('/2/user/binding', options)
  }

  const data = await post('/user/binding', options)

  return data
}

export async function qrLogin(qr, action = 'confirm') {
  const options = {
    body: {
      qr,
      action
    }
  }

  const data = await post('/user/qr', options)

  return data
}

export async function sendEmailCode(body) {
  if (getCaptcha()) {
    body={
      ...body,
      captcha: getCaptcha(),
    }
    return await post('/2/user/email', { body })
  }


  const data = await post('/user/email', { body })
  return data
}

//获取人机验证的方式
export const verifyMode = async () => {
  // if(window['captcha_type'])return
  const res = await get(`/2/captcha`, {})
  if(res.code===0){
    // sessionStorage.setItem('captcha_type',res.data.captcha_type)
    window['captcha_type']=res.data.captcha_type
    store.dispatch(createAction(CAPTCHA_TYPE, res.data.captcha_type))
    return res.data.captcha_type
  }
}

export const getQr = async () => {
  const res = await post(`/user/qr/req`,{
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  })
  return res
}
export const checkQr = async (qrid) => {
  const res = await get(`/user/qr/check?qrid=${qrid}`,{})
  return res
}

export const qr_login = async (body) => {
  const data= await post('/user/qr/signin', { body })
  if (data.status === OK) {
    setLoginInfo(data.data, data.data.token.access_token)
  }
  return data

}


export const delAccount = async () => {
  const res = await post('/user/delete',{})
  return res
}